import { useMutation, useQuery } from "@apollo/client";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { HandThumbDownIcon, HandThumbUpIcon } from "@heroicons/react/24/solid";
import ActionButton from "../../components/ActionButton/ActionButton";
import EmptyState from "../../components/EmptyState/EmptyState";
import { ErrorAlert } from "../../components/ErrorAlert/ErrorAlert";
import Loader from "../../components/Loader/Loader";
import Page from "../../components/Page/Page";
import Badge from "../../components/Styled/Badge";
import { Row } from "../../components/Styled/Container";
import {
  MediaActionRow,
  MediaActions,
  MediaCard,
  MediaFrame,
  MediaGrid,
  MediaImage,
} from "../../components/Styled/Media";
import { Group } from "../../graphql/graphql";
import { APPROVE_GROUP_PHOTO } from "../../graphql/mutations-gql";
import { GROUP_PHOTOS } from "../../graphql/queries-gql";

const GroupPhotos = () => {
  const { data, loading, error } = useQuery(GROUP_PHOTOS);
  const [approveGroupPhoto] = useMutation(APPROVE_GROUP_PHOTO);

  const groups: Group[] = data?.groupPhotos ?? [];

  const showImage = (src: string) => {
    //window.location.href = src;
    window.open(src, "_blank");
  };

  const handleApprove = (value: boolean, groupId: string) => {
    approveGroupPhoto({
      variables: {
        groupId,
        value,
      },
      onCompleted: (data) => {
        console.log("approveGroupPhoto onCompleted", data);
      },
      onError: (error) => {
        console.log("approveGroupPhoto onError", error);
      },
      refetchQueries: [GROUP_PHOTOS],
    });
  };

  return (
    <Page
      title="Group photos"
      description="Hover a photo to approve or reject it, click to open it full size."
      badge={
        groups.length > 0 && (
          <Badge $tone="primary">{groups.length} waiting</Badge>
        )
      }
    >
      {loading && (
        <Row justifyContent="center">
          <Loader />
        </Row>
      )}
      {error && <ErrorAlert error={error} />}

      {!loading && !error && groups.length === 0 && (
        <EmptyState
          Icon={PhotoIcon}
          title="No group photos to review"
          description="New group photos show up here."
        />
      )}

      {groups.length > 0 && (
        <MediaGrid $min={180} $gap={12}>
          {groups.map((group) => {
            return (
              <MediaCard key={group.photo?.uploadId}>
                <MediaFrame onClick={() => showImage(group.photo?.url ?? "")}>
                  <MediaImage
                    src={group.photo?.thumbnailUrl ?? ""}
                    alt=""
                    loading="lazy"
                  />
                  <MediaActions>
                    <MediaActionRow>
                      <ActionButton
                        label="Approve"
                        tone="approve"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleApprove(true, group._id);
                        }}
                      >
                        <HandThumbUpIcon />
                      </ActionButton>
                      <ActionButton
                        label="Reject"
                        tone="reject"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleApprove(false, group._id);
                        }}
                      >
                        <HandThumbDownIcon />
                      </ActionButton>
                    </MediaActionRow>
                  </MediaActions>
                </MediaFrame>
              </MediaCard>
            );
          })}
        </MediaGrid>
      )}
    </Page>
  );
};
export default GroupPhotos;
